import { QUITLINES, quitlineFor } from '@tahi/core';
import { useId } from 'react';
import { copy } from '../copy';
import { CARD, INPUT, LABEL, QUIET_LINK } from '../styles';

/** National quitline for the chosen country (data-driven, PH first) and the nicotine replacement note. */
export function SupportCard({
  country,
  onCountryChange,
}: {
  country: string | null;
  onCountryChange(c: string): void;
}) {
  const line = quitlineFor(country);
  const selectId = useId();
  return (
    <section aria-label={copy.support} className={CARD}>
      <h2 className={LABEL}>{copy.support}</h2>
      <a href={`tel:${line.tel}`} className={`${QUIET_LINK} mt-2 text-base`}>
        {copy.call(line.name, line.phone)}
      </a>
      {line.url ? (
        <a href={line.url} target="_blank" rel="noreferrer" className={QUIET_LINK}>
          {copy.website}
        </a>
      ) : null}
      <label htmlFor={selectId} className="mt-3 block text-sm text-muted">
        {copy.country}
      </label>
      <select
        id={selectId}
        value={line.country}
        onChange={(e) => onCountryChange(e.target.value)}
        className={`${INPUT} mt-1`}
      >
        {QUITLINES.map((q) => (
          <option key={q.country} value={q.country}>
            {q.countryName}
          </option>
        ))}
      </select>
      <p className="mt-3 text-sm text-muted">{copy.nrtNote}</p>
    </section>
  );
}
